import { createMultiStreamHook, createStreamHook } from '@/service/ws/use-web-socket-with-proto'
import { VenueHealth, VenueHealthStream } from '@/types/generated/public_api'

export const useVenueHealthStream = createStreamHook<VenueHealthStream, VenueHealth>({
  channelKey: 'venueHealthStream',
  extractResponse: (message, payload) => {
    const venueHealth = message.data?.venueHealth
    return venueHealth?.exchange === payload.exchange ? venueHealth : undefined
  },
  getPayloadDeps: (payload) => [payload.exchange],
  listenerChannelKey: 'venueHealthStream',
})

/** One shared wire subscription for symbols spread across several exchanges. */
export const useVenueHealthStreams = createMultiStreamHook<VenueHealthStream, VenueHealth>({
  channelKey: 'venueHealthStream',
  extractResponse: (message, payloads) => {
    const venueHealth = message.data?.venueHealth
    return venueHealth && payloads.some((payload) => payload.exchange === venueHealth.exchange)
      ? venueHealth
      : undefined
  },
  listenerChannelKey: 'venueHealthStream',
})
